// util
import { exception } from "./tracking";

import {
    openCISCOLoginPopup,
    isPageProtected,
    isPageProtectedByCCO,
    hashCiscoPermission,
} from "./socialLogin";


export function normalizeURL(state) {
    let changed = false;
    let { pathname, hash, search } = state.location;

    // clear url
    if (pathname.indexOf(".gsp") !== -1) {
        changed = true;
        pathname = pathname.replace(".gsp", ".html");
    }

    if (pathname.indexOf("index.html") !== -1) {
        changed = true;
        pathname = pathname.replace("index.html", "");
    }

    if (pathname.indexOf("#") === -1 && pathname.indexOf("?") === -1 && pathname.indexOf(".") === -1 && pathname.substr(-1) !== "/") {
        changed = true;
        pathname += "/";
    }

    if (search.indexOf("_escaped_fragment_") !== -1) {
        changed = true;

        hash = "#!" + search.slice(20);
        search = "";

        if (hash.substr(-1) !== "/") {
            hash += "/";
        }
    }

    const url = pathname + (hash || search);
    return { changed, pathname, url }
}


export function url_replace(replace) {
    return function (url) {
        if (url.startsWith("http")) {
            location.href = url;
            document.write("");
            return true;
        } else {
            replace(url);
            return false;
        }
    }
}


export function apply_routing_policy(state, replace, pathname) {

    let changed = false;
    let redirectHTTP = false;
    let { hash, search } = state.location;
    let newURL = location.href.replace(location.origin, '');

    if (window["PUBHUB_PATH_LIST"][pathname]) {
        return { changed, redirectHTTP, newURL };
    }


    // for supporting regex routing policy
    const reg = Object.keys(window["SITE_URL_MAPPING"]).find((rule) => {
        // for wildcard
        if (~rule.indexOf("*") || ~rule.indexOf("$")) {
            const re = new RegExp("^" + rule);
            if (re.test(pathname)) {
                return true;
            }
        }
    });

    if (reg) {
        changed = true;
        newURL = pathname.replace(new RegExp(reg), window["SITE_URL_MAPPING"][reg]) + (hash || search)
        redirectHTTP = replace(newURL);
    }


    // for redirect from SITE_URL_MAPPING
    if (window["SITE_URL_MAPPING"][pathname]) {
        changed = true;
        newURL = window["SITE_URL_MAPPING"][pathname] + (hash || search)
        redirectHTTP = replace(newURL);
    }

    //e.g. /wit
    if (window["SITE_URL_MAPPING"][pathname.slice(0, -1)]) {
        changed = true;
        newURL = window["SITE_URL_MAPPING"][pathname.slice(0, -1)] + (hash || search)
        redirectHTTP = replace(newURL);
    }


    // for site shortcut
    // e.g. : /google/ => /site/google/
    let _pathname = "/site" + pathname
    if (PUBHUB_PATH_LIST[_pathname]) {
        changed = true;
        newURL = _pathname + (hash || search);
        replace(newURL);
    }

    // for mapping hash
    // /xxx/#yyy => /xxx/aaa/yyy
    let _path = pathname + (hash || search);
    if (window["SITE_URL_MAPPING"][_path]) {
        changed = true;
        newURL = window["SITE_URL_MAPPING"][_path];
        replace(newURL);
    }


    return { changed, redirectHTTP, newURL };
}

export function apply_access_control(state, replace, pathname, prevState) {



    // check page is login required
    if (isPageProtected(pathname) && !PlatformSDK.isLoggedIn()) {

        //

        // replace(`/login`);
        PlatformSDK.openLogin()

        return false;
    }

    // check page is cisco sso required
    if (isPageProtectedByCCO(pathname) && !hashCiscoPermission()) {

        //
        //open cisco login popup
        //  if user close popup, fallback to previous url or homepage
        openCISCOLoginPopup(() => {
            const url = prevState ? prevState.location.pathname : "/";
            window.location.href = url;
        });
        return false
    }

    return true;
}


export function exception_404() {
    // send 404 to GA
    exception(`404${document.referrer ? `,referrer: ${document.referrer}` : ''}`);

    // replace("/")

}


export function pubhub_access_control(nextState, replace, callback) {
    const access_control = this.access_control;

    if (access_control == "public") {
        callback()
        return;
    }

    if (access_control == "sociallogin") {
        if (!PlatformSDK.isLoggedIn()) {
            PlatformSDK.openLogin()
        } else {
            callback()
        }
        return;
    }

    if (access_control.startsWith("access_level")) {
        const cco_access_level = access_control.slice(-1)
        if (!PlatformSDK.isLoggedIn() && !PlatformSDK.isNewUser()) {
            openCISCOLoginPopup(null, true)
        } else {
            PlatformSDK.fetchUserAccount().then(({ data }) => {
                if (data.provider == "ciscosso") {
                    if (data.accesslevel >= cco_access_level) {
                        callback()
                    } else {
                        replace("/403/")
                        callback()
                    }
                } else {
                    openCISCOLoginPopup(null, true)
                }

            }).catch(function () {
                replace("/403/")
                callback()
            })
        }

        return;
    }

    if (access_control == "profile_id_whitelisted") {
        const profile_ids = this.config.profile_id_whitelist;

        if (!profile_ids) {
            replace("/403/")
            callback()
            return;
        }

        if (!PlatformSDK.isLoggedIn()) {
            PlatformSDK.openLogin()
        } else {
            PlatformSDK.fetchUserAccount().then(({ data }) => {
                if (profile_ids.split(",").indexOf(data.profileID) == -1) {
                    replace("/403/")
                }
                callback()
            })
        }

        return;
    }

    if (access_control == "role_based_allowlist") {
        const allowlist = this.config.role_allowlist || "";

        if (!allowlist) {
            replace("/403/")
            callback()
            return;
        }

        if (!PlatformSDK.isLoggedIn()) {
            PlatformSDK.openLogin()
        } else {
            PlatformSDK.fetchUserAccount().then(({ data }) => {
                const roleAllowListMap = allowlist.split(",").reduce((pre, cur) => ({ ...pre, [cur.trim()]: true }), {});

                const permissions = (data.permissions || []);
                const noRolePermission = !permissions.find(i => roleAllowListMap[i.role])
                if (noRolePermission) {
                    replace("/403/");
                }
                callback();
            })
        }

        return;
    }

    replace("/403/");
    callback();
}

export function init_pubhub_projects() {
    if (!window["PUBHUB_PATH_LIST"]) {
        window["PUBHUB_PATH_LIST"] = {};
    }

    if (!window["PUBHUB_VERSION_LIST"]) {
        window["PUBHUB_VERSION_LIST"] = {};
    }

    _init_for_doc_version();
}


export function getCanonicalFromConfig(url) {
    if (!url) return url;

    const hashIndex = url.indexOf("#");
    const hashPart = hashIndex < 0 ? "" : url.substring(hashIndex);
    const pathPart = hashIndex < 0 ? url : url.substring(0, hashIndex);
    const relativeUrl = url.startsWith("http:") || url.startsWith("https:") ? pathPart.substring(window.location.origin.length) : pathPart;

    const pathItem = window["PUBHUB_PATH_LIST"][relativeUrl] || {};
    const canonicalUrl = pathItem.canonical || window["CANONICAL_MAP"][relativeUrl] || relativeUrl;

    return window.location.origin + canonicalUrl + hashPart;
}

function _init_for_doc_version() {
    if (window["CANONICAL_MAP"]) return null;

    const idPathMap = Object.values(window["PUBHUB_PATH_LIST"]).reduce((pre, cur) => ({
        ...pre,
        [cur.id]: cur
    }), {});

    window["CANONICAL_MAP"] = {};
    window["PUBHUB_CANONICAL_PATH_LIST"] = [];

    Object.values(window["PUBHUB_VERSION_LIST"]).forEach(docGroup => {
        const docList = Object.values(docGroup);
        const canonicalItem = docList.find(doc => doc.canonical && doc.is_latest_version);
        if (!canonicalItem) return;

        const canonicalPrj = idPathMap[canonicalItem.id];
        if (!canonicalPrj) return;

        const canonicalUrl = canonicalItem.canonical.endsWith("/") ? canonicalItem.canonical : canonicalItem.canonical + "/";

        window["PUBHUB_CANONICAL_PATH_LIST"][canonicalUrl] = canonicalPrj;
        window["PUBHUB_PATH_LIST"][canonicalUrl] = canonicalPrj;

        docList.forEach(doc => {
            const docPrj = idPathMap[doc.id];
            if (!docPrj) return;

            window["CANONICAL_MAP"][docPrj.url] = canonicalUrl;
        });
    });
}

export function eliminateUtmFromUrl(url) {
    if (!url.includes("?") || !url.includes("utm_")) return url;

    const urlParts = url.split("?");
    const path = urlParts[0];
    const paramParts = urlParts[1].split("#");
    const querystring = paramParts[0];
    const hashAfterQueryString = paramParts.length > 1 ? ("#" + paramParts[1]) : "";
    const querystringWithoutUtm = querystring.split("&")
        .filter(i => !i.startsWith("utm_"))
        .join("&");

    return path + (querystringWithoutUtm ? "?" + querystringWithoutUtm : "") + hashAfterQueryString;
}